"use client";

import { useEffect, useRef, useState } from "react";

const CHALLENGE_TEXT =
  "I need a fresh positioning angle for our product launch — everything I come up with feels like what everyone else is already saying...";

export default function DemoChallenge() {
  const [displayText, setDisplayText] = useState("");
  const [started, setStarted] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const wordCount = displayText.trim().split(/\s+/).filter(Boolean).length;
  const isComplete = displayText === CHALLENGE_TEXT;

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started) {
          setStarted(true);
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [started]);

  useEffect(() => {
    if (!started || isComplete) return;
    let index = 0;
    const interval = setInterval(() => {
      index++;
      setDisplayText(CHALLENGE_TEXT.slice(0, index));
      if (index >= CHALLENGE_TEXT.length) clearInterval(interval);
    }, 28);
    return () => clearInterval(interval);
  }, [started, isComplete]);

  return (
    <div ref={containerRef} className="w-full max-w-lg scrolly-reveal">
      <div className="border border-black/10 bg-white">
        {/* Label bar */}
        <div className="flex items-center justify-between gap-4 border-b border-black/10 px-4 py-3">
          <p className="text-[10px] uppercase tracking-[0.25em] text-gray-400 font-semibold">
            Thinknado Prompt
          </p>
          <p className="text-[10px] text-gray-400 tabular-nums">
            {wordCount} {wordCount === 1 ? "word" : "words"}
          </p>
        </div>

        {/* Typing area */}
        <div className="px-5 py-4 min-h-[110px]">
          <p className={`text-sm text-gray-900 leading-relaxed whitespace-pre-wrap ${!isComplete ? "scrolly-cursor" : ""}`}>
            {displayText || (
              <span className="text-gray-300">What are you thinking about?</span>
            )}
          </p>
        </div>

        {/* Footer bar */}
        <div className="border-t border-black/10 px-4 py-2.5">
          <p className="text-[10px] text-gray-400">
            Include context, constraints, and what&rsquo;s not working.
          </p>
        </div>
      </div>
    </div>
  );
}
